import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, MenuItem, TextField, Switch, FormControlLabel, IconButton, Tooltip } from '@mui/material';
import { Edit } from '@mui/icons-material';
import { useAppData } from '../../../../../../context/AppDataContext';

const TaskBasicInfoUpdate = ({ title, details, calendarType, callBack }) => {
    const [dialogStatus, setDialogStatus] = useState(false);
    
    // State for Title, Details, and Calendar Type
    const [inTitle, setInTitle] = useState(title || "");
    const [inDetails, setInDetails] = useState(details || "");
    const [inType, setInType] = useState(calendarType || 1);
    
    const [notify, setNotify] = useState(false);
    const [remark, setRemark] = useState("");

    const { masters, getMasterLabel } = useAppData();

    const handleUpdate = () => {
        if (!inTitle.trim()) return;

        if (callBack) {
            callBack({
                title: inTitle,
                details: inDetails,
                calendarType: inType,
                notify: notify,
                remark: remark
            });
        }
        setDialogStatus(false);
        setRemark("");
    };

    return (
        callBack &&
        <>
            <Tooltip title="Edit Basic Info">
                <IconButton 
                    onClick={() => setDialogStatus(true)} 
                    size="small" 
                    className="ms-2"
                    sx={{ border: '1px solid #e0e0e0' }}
                >
                    <Edit fontSize="small" />
                </IconButton>
            </Tooltip>

            <Dialog
                open={dialogStatus}
                onClose={() => setDialogStatus(false)}
                fullWidth={true}
                maxWidth="sm"
            >
                <div className='p-3 fw-bold border-bottom'>Edit Task Information</div>
                <DialogContent>
                    <div className='row mt-2'>
                        {/* Calendar Type Selection */}
                        <div className='col-md-12'>
                            <TextField
                                select
                                fullWidth
                                label="Calendar Type"
                                value={inType}
                                onChange={(e) => setInType(e.target.value)}
                                margin="normal"
                            >
                                {masters['calendar-type']?.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </div>

                        {/* Title */}
                        <div className='col-md-12'>
                            <TextField
                                fullWidth
                                label="Task Title"
                                value={inTitle}
                                onChange={(e) => setInTitle(e.target.value)}
                                margin="normal"
                                error={!inTitle.trim()}
                            />
                        </div>

                        {/* Details */}
                        <div className='col-md-12'>
                            <TextField
                                fullWidth
                                multiline
                                rows={5}
                                label="Task Details"
                                value={inDetails}
                                onChange={(e) => setInDetails(e.target.value)}
                                margin="normal"
                            />
                        </div>

                        {/* Remark Section */}
                        <div className='col-md-12 mt-2'>
                            <TextField
                                fullWidth
                                multiline
                                rows={2}
                                label="Update Remark"
                                value={remark}
                                onChange={(e) => setRemark(e.target.value)}
                                margin="normal"
                                placeholder="Why are you editing this task?"
                            />
                            
                            <FormControlLabel
                                control={
                                    <Switch 
                                        checked={notify} 
                                        onChange={(e) => setNotify(e.target.checked)} 
                                    />
                                }
                                label="Send updated Calendar Invite"
                            />
                        </div>
                    </div>
                </DialogContent>
                <DialogActions className="p-3">
                    <button className='btn btn-light' onClick={() => setDialogStatus(false)}>Cancel</button>
                    <button 
                        className='btn btn-primary' 
                        onClick={handleUpdate}
                        disabled={!inTitle.trim()}
                    >
                        Save Changes
                    </button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default TaskBasicInfoUpdate;